import { createApp, defineAsyncComponent } from 'vue';
import { i18n } from '../../setup/i18n';

export default function init() {
    // console.log('init form components');

    const instances = document.querySelectorAll('.dccs-form');
    Array.prototype.forEach.call(instances, el => {
        const app = createApp({});
        app.use(i18n)
            .component(
                'DccsForm',
                defineAsyncComponent(() => import('./DccsForm.vue'))
            )
            .component(
                'DccsCheckbox',
                defineAsyncComponent(() => import('./components/DccsCheckbox'))
            )
            .component(
                'DccsFileField',
                defineAsyncComponent(() => import('./components/DccsFileField'))
            )
            .component(
                'DccsHiddenField',
                defineAsyncComponent(() => import('./components/DccsHiddenField'))
            )
            .component(
                'DccsInputField',
                defineAsyncComponent(() => import('./components/DccsInputField'))
            )
            .component(
                'DccsTextarea',
                defineAsyncComponent(() => import('./components/DccsTextarea'))
            )
            .component(
                'DccsSelectField',
                defineAsyncComponent(() => import('./components/DccsSelectField'))
            )
            .component(
                'DccsRadio',
                defineAsyncComponent(() => import('./components/DccsRadio'))
            )
            .component(
                'DccsEmailInputField',
                defineAsyncComponent(() => import('./components/DccsEmailInputField'))
            )
            .component(
                'DccsCountrySelectField',
                defineAsyncComponent(() => import('./components/DccsCountrySelectField'))
            )
            .mount(el);
    });
}

/*
Vue.use(ReactiveProvide);

export default function init() {
    // console.log('init form components');

    const instances = document.querySelectorAll('.dccs-form');
    Array.prototype.forEach.call(
        instances,
        el =>
            new Vue({
                el,
                i18n,
                ignoredElements: ['lfr-drop-zone'],
                components: {
                    DccsForm: () => import('./DccsForm.vue'),
                    DccsCheckbox: () => import('./components/DccsCheckbox'),
                    DccsFileField: () => import('./components/DccsFileField'),
                    DccsHiddenField: () => import('./components/DccsHiddenField'),
                    DccsInputField: () => import('./components/DccsInputField'),
                    DccsTextarea: () => import('./components/DccsTextarea'),
                    DccsSelectField: () => import('./components/DccsSelectField'),
                    DccsRadio: () => import('./components/DccsRadio'),
                },
            })
    );
}
 */
